import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-last-year-comparison',
    imports: [CommonModule],
    templateUrl: './last-year-comparison.component.html',
    styleUrl: './last-year-comparison.component.scss'
})
export class LastYearComparisonComponent {
    loading = input<boolean>(false);
    totalReservations = input<number>(0);
    totalSeat = input<number>(0);
    lastYearReservations = input<number>(0);
    lastYearSeats = input<number>(0);
    comparisonReservation = input<{ value: number; status: string } | undefined>(undefined);
    comparisonSeat = input<{ value: number; status: string } | undefined>(undefined);

    readonly reservationBarWidth = computed(() => {
        const current = this.totalReservations();
        const last = this.lastYearReservations();
        const max = Math.max(current, last, 1);
        return Math.round((last / max) * 100);
    });

    readonly seatBarWidth = computed(() => {
        const current = this.totalSeat();
        const last = this.lastYearSeats();
        const max = Math.max(current, last, 1);
        return Math.round((last / max) * 100);
    });
}
